function LogIn() {

    return (
        // <!-- Log In content -->

        <div>
        
            <p
                id="logged-in-currently-as" 
                className="log-in-text content-block-text cover-page-centered">
                You are currently logged in as: example@bu.edu
            </p><br />

            <p
                id="log-in-select-project" 
                className="log-in-text content-block-text cover-page-centered">
                Select a project:
            </p>

            <div
                id="search-container"
                className="search-container">

                <input
                    className="search-input"
                    id="search-input"
                    onClick={() => { console.log('log-in-select-project') }}
                    placeholder="&nbsp;&nbsp;search here..."
                />
                <br/>
            
            </div>

            <p
                id="log-in-select-project" 
                className="log-in-text content-block-text cover-page-centered">
                Logged into [Project Name] 
            </p>
            <br/>

            <button 
                id="search-button"
                className="search-button content-block-text cover-page-centered">
                Log out of [Project Name] 
            </button>

        </div>
    )
};

export default LogIn;